import { CheckCircle2, Sparkles } from "lucide-react";
import { CardBadge } from "../../shared/card-badge";
import { SelectableCard } from "../../shared/selectable-card";

export type AdFormatOption = {
  id: string;
  title: string;
  description: string;
  bullets: string[];
  available: boolean;
};

type AdFormatCardProps = {
  option: AdFormatOption;
  selected: boolean;
  onSelect: () => void;
};

export function AdFormatCard({
  option,
  selected,
  onSelect,
}: AdFormatCardProps) {
  return (
    <SelectableCard
      interactive={option.available}
      selected={selected}
      dimmed={!option.available}
      onSelect={onSelect}
      className="tw:min-h-[380px]"
      contentClassName="tw:flex tw:h-full tw:flex-col"
    >
      <div className="tw:mb-3 tw:rounded-xl tw:border tw:bg-muted/30 tw:p-3">
        <div className="tw:flex tw:items-start tw:justify-between">
          <div className="tw:flex tw:items-center tw:gap-3">
            <div className="tw:flex tw:h-10 tw:w-10 tw:items-center tw:justify-center tw:rounded-lg tw:bg-sky-100 tw:text-sky-700">
              <Sparkles className="tw:h-4 tw:w-4" />
            </div>
            <CardBadge variant="secondary">Sponsored</CardBadge>
          </div>
          {option.available ? (
            selected ? (
              <CardBadge className="tw:bg-sky-500 tw:text-white">
                Selected
              </CardBadge>
            ) : null
          ) : (
            <CardBadge variant="outline">Coming soon</CardBadge>
          )}
        </div>
        <div className="tw:mt-3 tw:space-y-2">
          <div className="tw:h-2 tw:rounded-full tw:bg-sky-200" />
          <div className="tw:h-2 tw:w-2/3 tw:rounded-full tw:bg-sky-200" />
        </div>
      </div>

      <div className="tw:flex-1 tw:space-y-3">
        <div className="tw:flex tw:items-center tw:gap-2">
          <h2 className="tw:text-sm tw:font-semibold tw:text-foreground">
            {option.title}
          </h2>
          {selected ? (
            <CheckCircle2 className="tw:h-5 tw:w-5 tw:text-sky-500" />
          ) : null}
        </div>
        <p className="tw:text-sm tw:text-muted-foreground">
          {option.description}
        </p>
        <ul className="tw:space-y-2 tw:text-xs tw:text-muted-foreground">
          {option.bullets.map((bullet) => (
            <li key={bullet} className="tw:flex tw:gap-2">
              <span className="tw:text-sky-500">•</span>
              <span>{bullet}</span>
            </li>
          ))}
        </ul>
      </div>
    </SelectableCard>
  );
}
